// src/reducers/dashboard_reducers.js
import {
    FETCH_DASHBOARD_STATS_SUCCESS_Q1,
    FETCH_DASHBOARD_STATS_FAIL_Q1,
    FETCH_DASHBOARD_STATS_LOADING_Q1,
    FETCH_DASHBOARD_STATS_SUCCESS_Q2,
    FETCH_DASHBOARD_STATS_FAIL_Q2,
    FETCH_DASHBOARD_STATS_LOADING_Q2,
    FETCH_DASHBOARD_STATS_SUCCESS_Q3,
    FETCH_DASHBOARD_STATS_FAIL_Q3,
    FETCH_DASHBOARD_STATS_LOADING_Q3,
    FETCH_RECIPES_STATS_SUCCESS,
    FETCH_RECIPES_STATS_FAIL,
    FETCH_RECIPES_STATS_LOADING,
    FETCH_CUSTOM_RECIPES_STATS_SUCCESS,
    FETCH_CUSTOM_RECIPES_STATS_FAIL,
    FETCH_CUSTOM_RECIPES_STATS_LOADING,
    FETCH_RECIPES_STATS_WITH_PARAMS_SUCCESS,
    FETCH_RECIPES_STATS_WITH_PARAMS_FAIL,
    FETCH_RECIPES_STATS_WITH_PARAMS_LOADING,
    FETCH_DEVICE_RECIPES_STATS_SUCCESS,
    FETCH_DEVICE_RECIPES_STATS_FAIL,
    FETCH_DEVICE_RECIPES_STATS_LOADING,
    FETCH_CURATED_RECIPES_TILE_SEARCH_SUCCESS,
    FETCH_CURATED_RECIPES_TILE_SEARCH_FAIL,
    FETCH_CURATED_RECIPES_TILE_SEARCH_LOADING,
    FETCH_INGREDIENTS_TILE_SEARCH_LOADING,
    FETCH_INGREDIENTS_TILE_SEARCH_SUCCESS,
    FETCH_INGREDIENTS_TILE_SEARCH_FAIL,
    FETCH_BRANDS_TILE_SEARCH_LOADING,
    FETCH_BRANDS_TILE_SEARCH_SUCCESS,
    FETCH_BRANDS_TILE_SEARCH_FAIL,
    FETCH_INFLUENCERS_TILE_SEARCH_LOADING,
    FETCH_INFLUENCERS_TILE_SEARCH_SUCCESS,
    FETCH_INFLUENCERS_TILE_SEARCH_FAIL,
    FETCH_INFLUENCER_RECIPES_LOADING,
    FETCH_INFLUENCER_RECIPES_SUCCESS,
    FETCH_INFLUENCER_RECIPES_FAIL,
    FETCH_CURATED_RECIPES_V3_LOADING,
    FETCH_CURATED_RECIPES_V3_SUCCESS,
    FETCH_CURATED_RECIPES_V3_FAIL,
    FETCH_INGREDIENTS_V3_LOADING,
    FETCH_INGREDIENTS_V3_SUCCESS,
    FETCH_INGREDIENTS_V3_FAIL,
    FETCH_STATS_DATA_JSON_LOADING,
    FETCH_STATS_DATA_JSON_SUCCESS,
    FETCH_STATS_DATA_JSON_FAIL,
    FETCH_COUNTRY_DATA_JSON_LOADING,
    FETCH_COUNTRY_DATA_JSON_SUCCESS,
    FETCH_COUNTRY_DATA_JSON_FAIL,
    FETCH_SOURCE_DATA_JSON_LOADING,
    FETCH_SOURCE_DATA_JSON_SUCCESS,
    FETCH_SOURCE_DATA_JSON_FAIL,
    FETCH_PRODUCT_DATA_JSON_LOADING,
    FETCH_PRODUCT_DATA_JSON_SUCCESS,
    FETCH_PRODUCT_DATA_JSON_FAIL,
    FETCH_HARDWARE_CHART_TILE_INFO_LOADING,
    FETCH_HARDWARE_CHART_TILE_INFO_SUCCESS,
    FETCH_HARDWARE_CHART_TILE_INFO_FAIL,
    FETCH_BRANDS_V3_LOADING,
    FETCH_BRANDS_V3_SUCCESS,
    FETCH_BRANDS_V3_FAIL,
    FETCH_INFLUENCER_V3_LOADING,
    FETCH_INFLUENCER_V3_SUCCESS,
    FETCH_INFLUENCER_V3_FAIL,
    FETCH_COMPARE_USERS_WEEK_LOADING,
    FETCH_COMPARE_USERS_WEEK_SUCCESS,
    FETCH_COMPARE_USERS_WEEK_FAIL,
    FETCH_COMPARE_USERS_MONTH_LOADING,
    FETCH_COMPARE_USERS_MONTH_SUCCESS,
    FETCH_COMPARE_USERS_MONTH_FAIL,
    FETCH_COMPARE_USERS_YEAR_LOADING,
    FETCH_COMPARE_USERS_YEAR_SUCCESS,
    FETCH_COMPARE_USERS_YEAR_FAIL,
    FETCH_COMPARE_USERS_DAY_LOADING,
    FETCH_COMPARE_USERS_DAY_SUCCESS,
    FETCH_COMPARE_USERS_DAY_FAIL,
    FETCH_USER_RECIPES_LOADING,
    FETCH_USER_RECIPES_SUCCESS,
    FETCH_USER_RECIPES_FAIL,
    FETCH_CURATED_RECIPES_LOADING,
    FETCH_CURATED_RECIPES_SUCCESS,
    FETCH_CURATED_RECIPES_FAIL,
    FETCH_BRAND_RECIPES_LOADING,
    FETCH_BRAND_RECIPES_SUCCESS,
    FETCH_BRAND_RECIPES_FAIL,
    FETCH_PLAYLIST_MIXILISTS_LOADING,
    FETCH_PLAYLIST_MIXLISTS_SUCCESS,
    FETCH_PLAYLIST_MIXLISTS_FAIL,
    FETCH_PLAYLIST_BRANDS_LOADING,
    FETCH_PLAYLIST_BRANDS_SUCCESS,
    FETCH_PLAYLIST_BRANDS_FAIL,
    FETCH_PLAYLIST_INFLUENCERS_LOADING,
    FETCH_PLAYLIST_INFLUENCERS_SUCCESS,
    FETCH_PLAYLIST_INFLUENCERS_FAIL,
    FETCH_USER_TILE_INFO_LOADING,
    FETCH_USER_TILE_INFO_SUCCESS,
    FETCH_USER_TILE_INFO_FAIL,
    FETCH_ORDERS_LOADING,
    FETCH_ORDERS_SUCCESS,
    FETCH_ORDERS_FAIL,
    FETCH_ORDER_DETAILS_LOADING,
    FETCH_ORDER_DETAILS_SUCCESS,
    FETCH_ORDER_DETAILS_FAIL,
    FETCH_CRAFTED_COCKTAILS_EXPAND_LOADING,
    FETCH_CRAFTED_COCKTAILS_EXPAND_SUCCESS,
    FETCH_CRAFTED_COCKTAILS_EXPAND_FAIL,
    FETCH_HARDWARE_USAGE_STATS_LOADING,
    FETCH_HARDWARE_USAGE_STATS_SUCCESS,
    FETCH_HARDWARE_USAGE_STATS_FAIL,
    FETCH_COMPARE_USERS_LOADING,
    FETCH_COMPARE_USERS_SUCCESS,
    FETCH_COMPARE_USERS_FAIL,
  } from "../actions/types";
  
  const INITIAL_STATE = {
    //Users Comparison Expansion
    compare_users: [],        // holds the array of { period, registered_count, … }
    compare_users_error: null,
    loading_compare_users: false,

    // Hardware Usage Stats
    hardware_usage_expand_info: [],
    hardware_usage_expand_error:   null,
    loading_hardware_usage_expand: false,

    // Expanded Crafted Cocktails
    crafted_cocktails_expand_info: [],
    crafted_cocktails_expand_error: null,
    loading_crafted_cocktails_expand: false,

    // Q1 dashboard statistics
    stats_q1: null,
    error_q1: null,
    loading_q1: false,
  
    // Q2 dashboard statistics
    stats_q2: [],
    error_q2: null,
    loading_q2: false,
  
    // Q3 dashboard statistics
    stats_q3: [],
    error_q3: null,
    loading_q3: false,
  
    // Recipes statistics
    recipes_stats: [],
    recipes_error: null,
    loading_recipes_stats: false,
  
    // Custom recipes statistics
    custom_recipes_stats: [],
    custom_recipes_error: null,
    loading_custom_recipes_stats: false,
  
    // Recipes statistics with params
    recipes_stats_with_params: [],
    recipes_with_params_error: null,
    loading_recipes_stats_with_params: false,
  
    // Device recipes statistics
    device_recipes_stats: [],
    device_recipes_error: null,
    loading_device_recipes_stats: false,
  
    // Curated recipes tile information search
    curated_recipes_tile_info: [],
    curated_recipes_tile_error: null,
    loading_curated_recipes_tile_info: false,
  
    // Ingredients tile information search
    ingredients_tile_info: [],
    ingredients_tile_error: null,
    loading_ingredients_tile_info: false,

    // Initialize as an empty array (or null if preferred)
    brands_tile_info: [],
    brands_tile_error: null,
    loading_brands_tile_info: false,

    // Influencers tile information search
    influencers_tile_info: [],        // Initialize as empty array
    influencers_tile_error: null,     // Initialize error as null
    loading_influencers_tile_info: false, // Initialize loading as false

    // Influencer recipes
    influencer_recipes_info: [],
    influencer_recipes_error: null,
    loading_influencer_recipes: false,

    // New slice for curated recipes V3
    curated_recipes_v3_info: [],
    curated_recipes_v3_error: null,
    loading_curated_recipes_v3_info: false,

    // Ingredients V3 state
    ingredients_v3_info: [],
    ingredients_v3_error: null,
    loading_ingredients_v3_info: false,

    // State for stats-data-json endpoint
    stats_data_json: [],
    stats_data_json_error: null,
    loading_stats_data_json: false,

    // State for country-data-json endpoint
    country_data_json: [],
    country_data_json_error: null,
    loading_country_data_json: false,

    // State for source-data-json endpoint
    source_data_json: [],
    source_data_json_error: null,
    loading_source_data_json: false,

    // State for product-data-json endpoint
    product_data_json: [],
    product_data_json_error: null,
    loading_product_data_json: false,

    //Hardware Title Info V1
    hardware_chart_tile_info: {},
    hardware_chart_tile_info_error: null,
    hardware_chart_tile_info_loading: false,

    // New state slice for brands-v3 endpoint
    brands_v3: [],
    brands_v3_error: null,
    loading_brands_v3: false,

    // Top Products - Influencers Data V3
    influencerV3Data: [],
    loading_influencer_v3: false,
    errorInfluencerV3: null,

    // Compare Users data
    compare_users_week_info: [],
    compare_users_week_error: null,
    loading_compare_users_week: false,

    compare_users_month_info: [],
    compare_users_month_error: null,
    loading_compare_users_month: false,

    compare_users_year_info: [],
    compare_users_year_error: null,
    loading_compare_users_year: false,

    compare_users_day_info: [],
    compare_users_day_error: null,
    loading_compare_users_day: false,

    //New Recipes Data
    user_recipes_info: [],
    user_recipes_error: null,
    loading_user_recipes: false,
  
    curated_recipes_info: [],
    curated_recipes_error: null,
    loading_curated_recipes: false,
  
    brand_recipes_info: [],
    brand_recipes_error: null,
    loading_brand_recipes: false,

    //New Mixlists Data
    playlist_mixlists_info: [],
    playlist_mixlists_error: null,
    loading_playlist_mixlists: false,

    //New Brand Mixlist Data
    brand_mixlists_info: [],
    brand_mixlists_error: null,
    loading_brand_mixlists: false,

    //New Influencer Mixlist Data
    influencer_mixlists_info: [],
    influencer_mixlists_error: null,
    loading_influencer_mixlists: false,

    //User Tile Info
    user_tile_info: [],
    user_tile_info_error: null,
    loading_user_tile_info: false,

    //Orders
    orders_info: [],
    orders_info_error: null,
    loading_orders_info: false,

    order_details_info: [],
    order_details_error: null,
    loading_order_details: false,

  };
  
  
  const dashboardReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        //Users Comparison Expansion
        case FETCH_COMPARE_USERS_LOADING:
            return { ...state, loading_compare_users: true };

        case FETCH_COMPARE_USERS_SUCCESS:
            return {
                ...state,
                compare_users: action.payload || [],
                compare_users_error: null,
                loading_compare_users: false
            };

        case FETCH_COMPARE_USERS_FAIL:
            return {
                ...state,
                compare_users: [],
                compare_users_error: action.payload,
                loading_compare_users: false
            };
        //Hardware Usage Expansion
        case FETCH_HARDWARE_USAGE_STATS_LOADING:
            return {
                ...state,
                loading_hardware_usage_expand: true
            };

        case FETCH_HARDWARE_USAGE_STATS_SUCCESS:
            return {
                ...state,
                hardware_usage_expand_info: action.payload || [],
                hardware_usage_stats_error: null,
                loading_hardware_usage_expand: false
            };

        case FETCH_HARDWARE_USAGE_STATS_FAIL:
            return {
                ...state,
                hardware_usage_expand_info: [],
                hardware_usage_stats_error: action.payload,
                loading_hardware_usage_expand: false
            };

        //Crafted Cocktails Expansion
        case FETCH_CRAFTED_COCKTAILS_EXPAND_LOADING:
            return { ...state, loading_crafted_cocktails_expand: true };

        case FETCH_CRAFTED_COCKTAILS_EXPAND_SUCCESS:
            return {
                ...state,
                crafted_cocktails_expand_info: action.payload,
                crafted_cocktails_expand_error: null,
                loading_crafted_cocktails_expand: false,
            };

        case FETCH_CRAFTED_COCKTAILS_EXPAND_FAIL:
            return {
                ...state,
                crafted_cocktails_expand_info: [],
                crafted_cocktails_expand_error: action.payload,
                loading_crafted_cocktails_expand: false,
            };

        // Q1 statistics loading, success, and failure
        case FETCH_DASHBOARD_STATS_LOADING_Q1:
            return { ...state, loading_q1: true };
        case FETCH_DASHBOARD_STATS_SUCCESS_Q1:
            return { ...state, stats_q1: action.payload, error_q1: null, loading_q1: false };
        case FETCH_DASHBOARD_STATS_FAIL_Q1:
            return { ...state, stats_q1: null, error_q1: action.payload, loading_q1: false };

        // Q2 statistics loading, success, and failure
        case FETCH_DASHBOARD_STATS_LOADING_Q2:
            return { ...state, loading_q2: true };
        case FETCH_DASHBOARD_STATS_SUCCESS_Q2:
            return { ...state, stats_q2: action.payload, error_q2: null, loading_q2: false };
        case FETCH_DASHBOARD_STATS_FAIL_Q2:
            return { ...state, stats_q2: null, error_q2: action.payload, loading_q2: false };

        // Q3 statistics loading, success, and failure
        case FETCH_DASHBOARD_STATS_LOADING_Q3:
            return { ...state, loading_q3: true };
        case FETCH_DASHBOARD_STATS_SUCCESS_Q3:
            return { ...state, stats_q3: action.payload, error_q3: null, loading_q3: false };
        case FETCH_DASHBOARD_STATS_FAIL_Q3:
            return { ...state, stats_q3: null, error_q3: action.payload, loading_q3: false };

        // Recipes statistics loading, success, and failure
        case FETCH_RECIPES_STATS_LOADING:
            return { ...state, loading_recipes_stats: true };
        case FETCH_RECIPES_STATS_SUCCESS:
            return { ...state, recipes_stats: action.payload, recipes_error: null, loading_recipes_stats: false };
        case FETCH_RECIPES_STATS_FAIL:
            return { ...state, recipes_stats: null, recipes_error: action.payload, loading_recipes_stats: false };

        // Custom recipes statistics loading, success, and failure
        case FETCH_CUSTOM_RECIPES_STATS_LOADING:
            return { ...state, loading_custom_recipes_stats: true };
        case FETCH_CUSTOM_RECIPES_STATS_SUCCESS:
            return { ...state, custom_recipes_stats: action.payload, custom_recipes_error: null, loading_custom_recipes_stats: false };
        case FETCH_CUSTOM_RECIPES_STATS_FAIL:
            return { ...state, custom_recipes_stats: null, custom_recipes_error: action.payload, loading_custom_recipes_stats: false };

        // Recipes statistics with params loading, success, and failure
        case FETCH_RECIPES_STATS_WITH_PARAMS_LOADING:
            return { ...state, loading_recipes_stats_with_params: true };
        case FETCH_RECIPES_STATS_WITH_PARAMS_SUCCESS:
            return { ...state, recipes_stats_with_params: action.payload, recipes_with_params_error: null, loading_recipes_stats_with_params: false };
        case FETCH_RECIPES_STATS_WITH_PARAMS_FAIL:
            return { ...state, recipes_stats_with_params: null, recipes_with_params_error: action.payload, loading_recipes_stats_with_params: false };

        // Device recipes statistics loading, success, and failure
        case FETCH_DEVICE_RECIPES_STATS_LOADING:
            return { ...state, loading_device_recipes_stats: true };
        case FETCH_DEVICE_RECIPES_STATS_SUCCESS:
            return { ...state, device_recipes_stats: action.payload, device_recipes_error: null, loading_device_recipes_stats: false };
        case FETCH_DEVICE_RECIPES_STATS_FAIL:
            return { ...state, device_recipes_stats: null, device_recipes_error: action.payload, loading_device_recipes_stats: false };
  
        // Curated recipes tile information search loading, success, and failure
        case FETCH_CURATED_RECIPES_TILE_SEARCH_LOADING:
            return { ...state, loading_curated_recipes_tile_info: true };
        case FETCH_CURATED_RECIPES_TILE_SEARCH_SUCCESS:
            return { ...state, curated_recipes_tile_info: action.payload, curated_recipes_tile_error: null, loading_curated_recipes_tile_info: false };
        case FETCH_CURATED_RECIPES_TILE_SEARCH_FAIL:
            return { ...state, curated_recipes_tile_info: null, curated_recipes_tile_error: action.payload, loading_curated_recipes_tile_info: false };

        case FETCH_INGREDIENTS_TILE_SEARCH_LOADING:
            return {
                ...state,
                loading_ingredients_tile_info: true, // Start loading
            };
        case FETCH_INGREDIENTS_TILE_SEARCH_SUCCESS:
            return {
                ...state,
                ingredients_tile_info: action.payload, // Update state with fetched data
                ingredients_tile_error: null, // Clear any previous errors
                loading_ingredients_tile_info: false, // Stop loading
        };
        case FETCH_INGREDIENTS_TILE_SEARCH_FAIL:
            return {
                ...state,
                ingredients_tile_info: null, // Clear any existing data
                ingredients_tile_error: action.payload, // Store the error message
                loading_ingredients_tile_info: false, // Stop loading
        };

        // Brands tile information search cases
        case FETCH_BRANDS_TILE_SEARCH_LOADING:
            return { ...state, loading_brands_tile_info: true };
        case FETCH_BRANDS_TILE_SEARCH_SUCCESS:
            return { 
                ...state, 
                brands_tile_info: action.payload, 
                brands_tile_error: null, 
                loading_brands_tile_info: false 
            };
        case FETCH_BRANDS_TILE_SEARCH_FAIL:
            return { 
                ...state, 
                brands_tile_info: null, 
                brands_tile_error: action.payload, 
                loading_brands_tile_info: false 
            };
        
         // Influencers tile information search cases
        case FETCH_INFLUENCERS_TILE_SEARCH_LOADING:
            return { ...state, loading_influencers_tile_info: true };
        case FETCH_INFLUENCERS_TILE_SEARCH_SUCCESS:
            return { 
            ...state, 
            influencers_tile_info: action.payload, 
            influencers_tile_error: null, 
            loading_influencers_tile_info: false 
            };
        case FETCH_INFLUENCERS_TILE_SEARCH_FAIL:
            return { 
            ...state, 
            influencers_tile_info: null, 
            influencers_tile_error: action.payload, 
            loading_influencers_tile_info: false 
            };
        
        // Influencer recipes loading, success, and failure
        case FETCH_INFLUENCER_RECIPES_LOADING:
            return { ...state, loading_influencer_recipes: true };
        case FETCH_INFLUENCER_RECIPES_SUCCESS:
            return { 
            ...state, 
            influencer_recipes_info: action.payload, 
            influencer_recipes_error: null, 
            loading_influencer_recipes: false 
            };
        case FETCH_INFLUENCER_RECIPES_FAIL:
            return { 
            ...state, 
            influencer_recipes_info: null, 
            influencer_recipes_error: action.payload, 
            loading_influencer_recipes: false 
            };
        
        case FETCH_CURATED_RECIPES_V3_LOADING:
            return { ...state, loading_curated_recipes_v3_info: true };
        
        case FETCH_CURATED_RECIPES_V3_SUCCESS:
            return {
                ...state,
                curated_recipes_v3_info: action.payload,
                curated_recipes_v3_error: null,
                loading_curated_recipes_v3_info: false,
            };
        
        case FETCH_CURATED_RECIPES_V3_FAIL:
            return {
                ...state,
                curated_recipes_v3_info: null,
                curated_recipes_v3_error: action.payload,
                loading_curated_recipes_v3_info: false,
            };
        
        case FETCH_INGREDIENTS_V3_LOADING:
            return {
                ...state,
                loading_ingredients_v3_info: true,
            };
            
        case FETCH_INGREDIENTS_V3_SUCCESS:
            return {
                ...state,
                ingredients_v3_info: action.payload,
                ingredients_v3_error: null,
                loading_ingredients_v3_info: false,
            };
            
        case FETCH_INGREDIENTS_V3_FAIL:
            return {
                ...state,
                ingredients_v3_info: null,
                ingredients_v3_error: action.payload,
                loading_ingredients_v3_info: false,
            };

        case FETCH_STATS_DATA_JSON_LOADING:
            return {
            ...state,
            loading_stats_data_json: true,
            };

        case FETCH_STATS_DATA_JSON_SUCCESS:
        return {
            ...state,
            stats_data_json: action.payload,
            stats_data_json_error: null,
            loading_stats_data_json: false,
        };

        case FETCH_STATS_DATA_JSON_FAIL:
        return {
            ...state,
            stats_data_json: [],
            stats_data_json_error: action.payload,
            loading_stats_data_json: false,
        };

        case FETCH_COUNTRY_DATA_JSON_LOADING:
            return {
              ...state,
              loading_country_data_json: true,
            };
      
          case FETCH_COUNTRY_DATA_JSON_SUCCESS:
            return {
              ...state,
              country_data_json: action.payload,
              country_data_json_error: null,
              loading_country_data_json: false,
            };
      
          case FETCH_COUNTRY_DATA_JSON_FAIL:
            return {
              ...state,
              country_data_json: [],
              country_data_json_error: action.payload,
              loading_country_data_json: false,
            };

        case FETCH_SOURCE_DATA_JSON_LOADING:
            return {
                ...state,
                loading_source_data_json: true,
            };

        case FETCH_SOURCE_DATA_JSON_SUCCESS:
            return {
                ...state,
                source_data_json: action.payload,
                source_data_json_error: null,
                loading_source_data_json: false,
            };

        case FETCH_SOURCE_DATA_JSON_FAIL:
            return {
                ...state,
                source_data_json: [],
                source_data_json_error: action.payload,
                loading_source_data_json: false,
            };
    
        case FETCH_PRODUCT_DATA_JSON_LOADING:
            return {
                ...state,
                loading_product_data_json: true,
            };
        
        case FETCH_PRODUCT_DATA_JSON_SUCCESS:
            return {
                ...state,
                product_data_json: action.payload,
                product_data_json_error: null,
                loading_product_data_json: false,
            };
        
        case FETCH_PRODUCT_DATA_JSON_FAIL:
            return {
                ...state,
                product_data_json: [],
                product_data_json_error: action.payload,
                loading_product_data_json: false,
            };

        //Hardware Title Info V1
        case FETCH_HARDWARE_CHART_TILE_INFO_LOADING:
            return {
                ...state,
                hardware_chart_tile_info_loading: true,
            };
            case FETCH_HARDWARE_CHART_TILE_INFO_SUCCESS:
            return {
                ...state,
                hardware_chart_tile_info: action.payload,
                hardware_chart_tile_info_error: null,
                hardware_chart_tile_info_loading: false,
            };
            case FETCH_HARDWARE_CHART_TILE_INFO_FAIL:
            return {
                ...state,
                hardware_chart_tile_info: null,
                hardware_chart_tile_info_error: action.payload,
                hardware_chart_tile_info_loading: false,
            };
            
            // Brands v3 cases
            case FETCH_BRANDS_V3_LOADING:
                return { ...state, loading_brands_v3: true };
            case FETCH_BRANDS_V3_SUCCESS:
                return { 
                ...state, 
                brands_v3: action.payload, 
                brands_v3_error: null, 
                loading_brands_v3: false 
                };
            case FETCH_BRANDS_V3_FAIL:
                return { 
                ...state, 
                brands_v3: null, 
                brands_v3_error: action.payload, 
                loading_brands_v3: false 
                };

                case FETCH_INFLUENCER_V3_LOADING:
                return {
                    ...state,
                    loading_influencer_v3: true,
                    errorInfluencerV3: null,
                };

                case FETCH_INFLUENCER_V3_SUCCESS:
                return {
                    ...state,
                    loading_influencer_v3: false,
                    influencerV3Data: action.payload,
                };

                case FETCH_INFLUENCER_V3_FAIL:
                return {
                    ...state,
                    loading_influencer_v3: false,
                    errorInfluencerV3: action.payload,
                };

                // Compare Users – Week
                case FETCH_COMPARE_USERS_WEEK_LOADING:
                    return { ...state, loading_compare_users_week: true };
                case FETCH_COMPARE_USERS_WEEK_SUCCESS:
                    return {
                    ...state,
                    compare_users_week_info: action.payload,
                    compare_users_week_error: null,
                    loading_compare_users_week: false,
                    };
                case FETCH_COMPARE_USERS_WEEK_FAIL:
                    return {
                    ...state,
                    compare_users_week_info: null,
                    compare_users_week_error: action.payload,
                    loading_compare_users_week: false,
                    };
                
                // Compare Users – Month
                case FETCH_COMPARE_USERS_MONTH_LOADING:
                    return { ...state, loading_compare_users_month: true };
                case FETCH_COMPARE_USERS_MONTH_SUCCESS:
                    return {
                    ...state,
                    compare_users_month_info: action.payload,
                    compare_users_month_error: null,
                    loading_compare_users_month: false,
                    };
                case FETCH_COMPARE_USERS_MONTH_FAIL:
                    return {
                    ...state,
                    compare_users_month_info: null,
                    compare_users_month_error: action.payload,
                    loading_compare_users_month: false,
                    };
                
                // Compare Users – Year
                case FETCH_COMPARE_USERS_YEAR_LOADING:
                    return { ...state, loading_compare_users_year: true };
                case FETCH_COMPARE_USERS_YEAR_SUCCESS:
                    return {
                    ...state,
                    compare_users_year_info: action.payload,
                    compare_users_year_error: null,
                    loading_compare_users_year: false,
                    };
                case FETCH_COMPARE_USERS_YEAR_FAIL:
                    return {
                    ...state,
                    compare_users_year_info: null,
                    compare_users_year_error: action.payload,
                    loading_compare_users_year: false,
                    };
                
                // Compare Users – Day
                case FETCH_COMPARE_USERS_DAY_LOADING:
                    return { ...state, loading_compare_users_day: true };
                case FETCH_COMPARE_USERS_DAY_SUCCESS:
                    return {
                        ...state,
                        compare_users_day_info: action.payload,
                        compare_users_day_error: null,
                        loading_compare_users_day: false,
                    };
                case FETCH_COMPARE_USERS_DAY_FAIL:
                    return {
                        ...state,
                        compare_users_day_info: null,
                        compare_users_day_error: action.payload,
                        loading_compare_users_day: false,
                    };
                // NEW Recipes - Dashboard
                case FETCH_USER_RECIPES_LOADING:
                    return { ...state, loading_user_recipes: true };
                case FETCH_USER_RECIPES_SUCCESS:
                    return { 
                            ...state, 
                            user_recipes_info: action.payload, 
                            user_recipes_error: null, 
                            loading_user_recipes: false 
                    };
                case FETCH_USER_RECIPES_FAIL:
                    return { 
                            ...state, 
                            user_recipes_info: [], 
                            user_recipes_error: action.payload, 
                            loading_user_recipes: false 
                    };
                
                    case FETCH_CURATED_RECIPES_LOADING:
                    return { ...state, loading_curated_recipes: true };
                    case FETCH_CURATED_RECIPES_SUCCESS:
                    return { 
                            ...state, 
                            curated_recipes_info: action.payload, 
                            curated_recipes_error: null, 
                            loading_curated_recipes: false 
                    };
                    case FETCH_CURATED_RECIPES_FAIL:
                    return { ...state, curated_recipes_info: [], curated_recipes_error: action.payload, loading_curated_recipes: false };
                
                    case FETCH_BRAND_RECIPES_LOADING:
                    return { ...state, loading_brand_recipes: true };
                    case FETCH_BRAND_RECIPES_SUCCESS:
                    return { 
                            ...state, 
                            brand_recipes_info: action.payload, 
                            brand_recipes_error: null, 
                            loading_brand_recipes: false 
                    };
                    case FETCH_BRAND_RECIPES_FAIL:
                    return { ...state, brand_recipes_info: [], brand_recipes_error: action.payload, loading_brand_recipes: false };  
                    
                    //Playlist/Brand/Influencers Mixlists
                    case FETCH_PLAYLIST_MIXLISTS_FAIL:
                        return { ...state, 
                                 playlist_mixlists_info: [], 
                                 playlist_mixlists_error: action.payload, 
                                 loading_playlist_mixlists: false 
                        };
                    case FETCH_PLAYLIST_MIXILISTS_LOADING:
                        return { ...state, loading_playlist_mixlists: true };
                    case FETCH_PLAYLIST_MIXLISTS_SUCCESS:
                        // console.log('PLAYLIST REDUCER',action.payload)
                        const { mixlist } = action.payload;
                        return { 
                                ...state, 
                                playlist_mixlists_info: Array.isArray(mixlist) ? mixlist : [], 
                                playlist_mixlists_error: null, 
                                loading_playlist_mixlists: false 
                        };
                        //For Brands
                        case FETCH_PLAYLIST_BRANDS_FAIL:
                            return { ...state, 
                                    brand_mixlists_info: [], 
                                    brand_mixlists_error: action.payload, 
                                    loading_brand_mixlists: false 
                            };
                        case FETCH_PLAYLIST_BRANDS_LOADING:
                            return { ...state, loading_brand_mixlists: true };
                        case FETCH_PLAYLIST_BRANDS_SUCCESS: {
                            const payload = action.payload ?? {};
                            // accept either an array OR an object with mixlist (or brand as fallback)
                            const list = Array.isArray(payload)
                                ? payload
                                : (payload.mixlist ?? payload.brand ?? []);
                            return {
                                ...state,
                                brand_mixlists_info: Array.isArray(list) ? list : [],
                                brand_mixlists_error: null,
                                loading_brand_mixlists: false,
                            };
                        }
                        //For Influencers
                        case FETCH_PLAYLIST_INFLUENCERS_FAIL:
                            return { ...state, 
                                    influencer_mixlists_info: [], 
                                    influencer_mixlists_error: action.payload, 
                                    loading_influencer_mixlists: false 
                            };
                        case FETCH_PLAYLIST_INFLUENCERS_LOADING:
                            return { ...state, loading_influencer_mixlists: true };
                        case FETCH_PLAYLIST_INFLUENCERS_SUCCESS:
                            // console.log('BRAND PLAYLIST REDUCER',action.payload)
                            const { influencer } = action.payload;
                            return { 
                                    ...state, 
                                    influencer_mixlists_info: Array.isArray(influencer) ? influencer : [], 
                                    influencer_mixlists_error: null, 
                                    loading_influencer_mixlists: false 
                            };
                        //User Tile Info - Dashboard Expand Chart
                        case FETCH_USER_TILE_INFO_FAIL:
                            return { ...state, 
                                user_tile_info: [], 
                                user_tile_info_error: action.payload, 
                                loading_user_tile_info: false 
                            };
                        case FETCH_USER_TILE_INFO_LOADING:
                            return { ...state, loading_user_tile_info: true };
                        case FETCH_USER_TILE_INFO_SUCCESS:
                            // console.log('Payload in reducer FETCH_USER_TILE_INFO_SUCCESS:');
                            return { 
                                ...state, 
                                user_tile_info: action.payload && action.payload.dateswise && Array.isArray(action.payload.dateswise)
                                ? action.payload.dateswise
                                : [],
                                user_tile_info_error: null, 
                                loading_user_tile_info: false 
                            };
                        //Orders
                        case FETCH_ORDERS_FAIL:
                            return { ...state, 
                                orders_info: [], 
                                orders_info_error: action.payload, 
                                loading_orders_info: false 
                            };
                        case FETCH_ORDERS_LOADING:
                            return { ...state, loading_orders_info: true };
                        case FETCH_ORDERS_SUCCESS:
                            // console.log('Payload in reducer FETCH_ORDERS_SUCCESS:' action.payload);
                            return { 
                                ...state, 
                                orders_info: action.payload,
                                orders_info_error: null, 
                                loading_orders_info: false 
                            };
                        case FETCH_ORDER_DETAILS_FAIL:
                            return { ...state, 
                                order_details_info: [], 
                                order_details_error: action.payload, 
                                loading_order_details: false 
                            };
                        case FETCH_ORDER_DETAILS_LOADING:
                            return { ...state, loading_order_details: true };
                        case FETCH_ORDER_DETAILS_SUCCESS:
                            console.log('Payload in reducer FETCH_ORDER_DETAILS_SUCCESS', action.payload);
                            return { 
                                ...state, 
                                order_details_info: action.payload,
                                order_details_error: null, 
                                loading_order_details: false 
                            };        
    default:
        return state;
    }
};
  
  export default dashboardReducer;
  